import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="social-links">
            <Link to="/facebook" className="social-link">
              <i className="fab fa-facebook-f"></i>
              <span>Facebook</span>
            </Link>
            <Link to="/twitter" className="social-link">
              <i className="fab fa-twitter"></i>
              <span>Twitter</span>
            </Link>
            <Link to="/instagram" className="social-link">
              <i className="fab fa-instagram"></i>
              <span>Instagram</span>
            </Link>
            <Link to="/linkedin" className="social-link">
              <i className="fab fa-linkedin-in"></i>
              <span>LinkedIn</span>
            </Link>
            <Link to="/youtube" className="social-link">
              <i className="fab fa-youtube"></i>
              <span>YouTube</span>
            </Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 MarcoDeMarco&trade; ~ All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
